export default __webpack_public_path__ + "static/media/attention2.e0ce1e74.mp3";